import type {
  HotelDeals_HotelDeal,
  Hotels_GetHotelDeals_V2_GetHotelDealsQueryV2Response_Success,
} from "../../swagger-types/v1/index.js";
import { cloneDeep } from "lodash-es";

type HotelDealWithRoomIds = HotelDeals_HotelDeal & {
  rates: Array<{
    roomId: number | null;
    roomCode: string;
    roomName: string;
  }>;
};

export type HotelDealsResponseWithRoomIds = Omit<
  Hotels_GetHotelDeals_V2_GetHotelDealsQueryV2Response_Success,
  "deals"
> & {
  deals: HotelDealWithRoomIds[];
};

export const getHotelDealsResponseMock = (): {
  [key: string]: Hotels_GetHotelDeals_V2_GetHotelDealsQueryV2Response_Success;
} => ({
  default: hotelDealsResponseFake,
  rdm1: { ...cloneDeep(hotelDealsResponseFake), rateModel: "Net" },
  cheapestDealNotAvailable: { ...cloneDeep(hotelDealsResponseFake), cheapestDealAvailabilityState: "NotAvailable" },
  cheapestDealUnknown: { ...cloneDeep(hotelDealsResponseFake), cheapestDealAvailabilityState: "Unknown" },
  cheapestDealVerificationFailed: hotelDealsCheapestDealVerificationFailedResponseFake,
  noDealsFound: hotelDealsNoDealsResponseFake,
  cancellationPolicyEnforced: {
    ...cloneDeep(hotelDealsResponseFake),
    deals: [
      { ...cloneDeep(hotelDealsResponseFake.deals[0]), cancellationPolicyEnforced: true },
      ...cloneDeep(hotelDealsResponseFake.deals.slice(1)),
    ],
  },
});

export const createHotelDealsResponseMock = (
  roomName: string,
): Hotels_GetHotelDeals_V2_GetHotelDealsQueryV2Response_Success => {
  return {
    isCompleted: true,
    requestKey: null,
    rateModel: "AllInclusive",
    deals: [
      {
        cancellationPolicyEnforced: null,
        checkoutId: "5377694d-f235-4f95-9104-470d4cdbc7bc",
        dealType: "FullRange",
        roomName: `Standard Room ${roomName}`,
        roomCode: "4cdc2bb3-ab9a-4fce-9afc-d6571a01c853",
        boardCode: "HalfBoard",
        boardDescription: "Half Board",
        checkIn: "2025-08-18",
        checkOut: "2025-08-20",
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
          penalties: [
            {
              from: "2025-08-09T05:28:30.7189468Z",
              to: null,
              amount: {
                amount: 276.0,
                currency: "USD",
              },
            },
          ],
          description:
            "This room is non-refundable and cannot be changed. No-shows and early checkouts are not eligible for a refund.",
        },
        fees: {
          total: 112.51,
          currencyCode: "USD",
          items: [
            {
              code: "CityTax",
              amount: 7.0,
              currencyCode: "USD",
              description: "government tax",
            },
            {
              code: "CityTax",
              amount: 91.8,
              currencyCode: "USD",
              description: "Destination fee",
            },
            {
              code: "CityTax",
              amount: 13.71,
              currencyCode: "USD",
              description: "City tax",
            },
          ],
        },
        taxes: {
          total: 9.08,
          currencyCode: "USD",
          items: [
            {
              code: "Vat",
              amount: 9.08,
              currencyCode: "USD",
              description: "Tax",
            },
          ],
        },
        hotelFees: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        hotelFeeTaxes: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        rooms: [
          {
            roomCode: "4cdc2bb3-ab9a-4fce-9afc-d6571a01c853",
            roomName: "Standard Room",
            boardCode: "HalfBoard",
            boardDescription: "Half Board",
            checkIn: "2025-08-18",
            checkOut: "2025-08-20",
          },
        ],
        dealPrice: {
          currencyCode: "USD",
          nightlyPrice: 77.2,
          totalRoomsPrice: 154.41,
          totalPrice: 276.0,
          totalPriceWithHotelFees: 276.0,
          totalRoomsPriceWithHotelFees: 154.41,
        },
        verificationStatus: "Verified",
        dealIndex: 1,
        roomDealIndex: 1,
        roomIndex: 1,
        roomId: 101,
      },
      {
        cancellationPolicyEnforced: null,
        checkoutId: "5df697f2-0cf8-4bad-b064-bd51ae4da4db",
        dealType: "FullRange",
        roomName: "Deluxe Room",
        roomCode: "7bf9a2ea-ec1d-4215-b4cf-559b61f035be",
        boardCode: "FullBoard",
        boardDescription: "Full Board",
        checkIn: "2025-08-18",
        checkOut: "2025-08-20",
        cancellationPolicy: {
          type: "Refundable",
          deadline: "2025-08-14T11:59:59Z",
          penalties: [
            {
              from: "2025-08-14T11:59:59Z",
              to: null,
              amount: {
                amount: 306.0,
                currency: "USD",
              },
            },
          ],
          description:
            "Cancellations before Aug 14, 2025 11:59 AM (UTC) are fully refundable. Bookings canceled after Aug 14, 2025 11:59 AM (UTC) are non-refundable and cannot be amended. There is no refund for no-shows or early checkouts.",
        },
        fees: {
          total: 114.83,
          currencyCode: "USD",
          items: [
            {
              code: "CityTax",
              amount: 7.0,
              currencyCode: "USD",
              description: "government tax",
            },
            {
              code: "CityTax",
              amount: 91.8,
              currencyCode: "USD",
              description: "Destination fee",
            },
            {
              code: "CityTax",
              amount: 16.03,
              currencyCode: "USD",
              description: "City tax",
            },
          ],
        },
        taxes: {
          total: 10.62,
          currencyCode: "USD",
          items: [
            {
              code: "Vat",
              amount: 10.62,
              currencyCode: "USD",
              description: "Tax",
            },
          ],
        },
        hotelFees: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        hotelFeeTaxes: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        rooms: [
          {
            roomCode: "7bf9a2ea-ec1d-4215-b4cf-559b61f035be",
            roomName: "Deluxe Room",
            boardCode: "FullBoard",
            boardDescription: "Full Board",
            checkIn: "2025-08-18",
            checkOut: "2025-08-20",
          },
        ],
        dealPrice: {
          currencyCode: "USD",
          nightlyPrice: 90.28,
          totalRoomsPrice: 180.55,
          totalPrice: 306.0,
          totalPriceWithHotelFees: 306.0,
          totalRoomsPriceWithHotelFees: 180.55,
        },
        verificationStatus: "Verified",
        dealIndex: 2,
        roomDealIndex: 1,
        roomIndex: 2,
        roomId: 202,
      },
      {
        cancellationPolicyEnforced: null,
        checkoutId: "a1f78c5c-79ba-43f6-a64e-af0f9ba4d740",
        dealType: "FullRange",
        roomName: "Standard Double Bed Room",
        roomCode: "36537548-8870-456a-899c-3bf30e285937",
        boardCode: "AllInclusive",
        boardDescription: "All Inclusive",
        checkIn: "2025-08-18",
        checkOut: "2025-08-20",
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
          penalties: [
            {
              from: "2025-08-08T11:59:59Z",
              to: null,
              amount: {
                amount: 396.01,
                currency: "USD",
              },
            },
          ],
          description:
            "This room is non-refundable and cannot be changed. No-shows and early checkouts are not eligible for a refund.",
        },
        fees: {
          total: 121.8,
          currencyCode: "USD",
          items: [
            {
              code: "CityTax",
              amount: 7.0,
              currencyCode: "USD",
              description: "government tax",
            },
            {
              code: "CityTax",
              amount: 91.8,
              currencyCode: "USD",
              description: "Destination fee",
            },
            {
              code: "CityTax",
              amount: 23.0,
              currencyCode: "USD",
              description: "City tax",
            },
          ],
        },
        taxes: {
          total: 15.23,
          currencyCode: "USD",
          items: [
            {
              code: "Vat",
              amount: 15.23,
              currencyCode: "USD",
              description: "Tax",
            },
          ],
        },
        hotelFees: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        hotelFeeTaxes: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        rooms: [
          {
            roomCode: "36537548-8870-456a-899c-3bf30e285937",
            roomName: "Standard Double Bed Room",
            boardCode: "AllInclusive",
            boardDescription: "All Inclusive",
            checkIn: "2025-08-18",
            checkOut: "2025-08-20",
          },
        ],
        dealPrice: {
          currencyCode: "USD",
          nightlyPrice: 129.49,
          totalRoomsPrice: 258.98,
          totalPrice: 396.01,
          totalPriceWithHotelFees: 396.01,
          totalRoomsPriceWithHotelFees: 258.98,
        },
        verificationStatus: "Verified",
        dealIndex: 3,
        roomDealIndex: 1,
        roomIndex: 3,
        roomId: 303,
      },
      {
        cancellationPolicyEnforced: null,
        checkoutId: "a1f78c5c-79ba-43f6-a64e-af0f9ba4d741",
        dealType: "FullRange",
        roomName: "Standard Double Bed Room",
        roomCode: "36537548-8870-456a-899c-3bf30e285937",
        boardCode: "AllInclusive",
        boardDescription: "All Inclusive",
        checkIn: "2025-08-18",
        checkOut: "2025-08-20",
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
          penalties: [
            {
              from: "2025-08-08T11:59:59Z",
              to: null,
              amount: {
                amount: 396.01,
                currency: "USD",
              },
            },
          ],
          description:
            "This room is non-refundable and cannot be changed. No-shows and early checkouts are not eligible for a refund.",
        },
        fees: {
          total: 121.8,
          currencyCode: "USD",
          items: [
            {
              code: "CityTax",
              amount: 7.0,
              currencyCode: "USD",
              description: "government tax",
            },
            {
              code: "CityTax",
              amount: 91.8,
              currencyCode: "USD",
              description: "Destination fee",
            },
            {
              code: "CityTax",
              amount: 23.0,
              currencyCode: "USD",
              description: "City tax",
            },
          ],
        },
        taxes: {
          total: 15.23,
          currencyCode: "USD",
          items: [
            {
              code: "Vat",
              amount: 15.23,
              currencyCode: "USD",
              description: "Tax",
            },
          ],
        },
        hotelFees: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        hotelFeeTaxes: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        rooms: [
          {
            roomCode: "36537548-8870-456a-899c-3bf30e285937",
            roomName: "Standard Double Bed Room",
            boardCode: "AllInclusive",
            boardDescription: "All Inclusive",
            checkIn: "2025-08-18",
            checkOut: "2025-08-20",
          },
        ],
        dealPrice: {
          currencyCode: "USD",
          nightlyPrice: 129.49,
          totalRoomsPrice: 258.98,
          totalPrice: 396.01,
          totalPriceWithHotelFees: 396.01,
          totalRoomsPriceWithHotelFees: 258.98,
        },
        verificationStatus: "Verified",
        dealIndex: 4,
        roomDealIndex: 2,
        roomIndex: 3,
        roomId: 303,
      },
    ],
    hotelRooms: [
      {
        roomCode: "4cdc2bb3-ab9a-4fce-9afc-d6571a01c853",
        roomName: `Standard Room ${roomName}`,
      },
      {
        roomCode: "7bf9a2ea-ec1d-4215-b4cf-559b61f035be",
        roomName: "Deluxe Room",
      },
      {
        roomCode: "36537548-8870-456a-899c-3bf30e285937",
        roomName: "Standard Double Bed Room",
      },
    ],
    cheapestDealAvailabilityState: "Available",
    roomIds: [101, 202, 303],
  };
};

export const createHotelDealsResponseWithRoomIdsMock = (
  roomIds: number[],
  {
    isCompleted = true,
    requestKey = null,
    dealRoomIds,
  }: { isCompleted?: boolean; requestKey?: string | null; dealRoomIds?: Array<number | null> } = {},
): HotelDealsResponseWithRoomIds => {
  const response = cloneDeep(hotelDealsResponseFake);

  return {
    ...response,
    isCompleted,
    requestKey,
    roomIds,
    deals: response.deals.map((deal, index) => {
      const roomId = dealRoomIds ? (dealRoomIds[index] ?? null) : (roomIds[index] ?? null);

      return {
        ...deal,
        roomId,
        rates: [
          {
            roomId,
            roomCode: deal.roomCode,
            roomName: deal.roomName,
          },
        ],
      };
    }),
  };
};

const hotelDealsResponseFake: Hotels_GetHotelDeals_V2_GetHotelDealsQueryV2Response_Success =
  createHotelDealsResponseMock("");

const hotelDealsNoDealsResponseFake: Hotels_GetHotelDeals_V2_GetHotelDealsQueryV2Response_Success = {
  isCompleted: true,
  requestKey: null,
  rateModel: "AllInclusive",
  deals: [],
  hotelRooms: [],
  cheapestDealAvailabilityState: "Unknown",
  roomIds: [],
};

const hotelDealsCheapestDealVerificationFailedResponseFake: Hotels_GetHotelDeals_V2_GetHotelDealsQueryV2Response_Success =
  {
    isCompleted: true,
    requestKey: null,
    rateModel: "AllInclusive",
    deals: [
      {
        cancellationPolicyEnforced: null,
        checkoutId: "5377694d-f235-4f95-9104-470d4cdbc7bc",
        dealType: "FullRange",
        roomName: "Standard Room",
        roomCode: "4cdc2bb3-ab9a-4fce-9afc-d6571a01c853",
        boardCode: "HalfBoard",
        boardDescription: "Half Board",
        checkIn: "2025-08-18",
        checkOut: "2025-08-20",
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
          penalties: [
            {
              from: "2025-08-09T05:28:30.7189468Z",
              to: null,
              amount: {
                amount: 276.0,
                currency: "USD",
              },
            },
          ],
          description:
            "This room is non-refundable and cannot be changed. No-shows and early checkouts are not eligible for a refund.",
        },
        fees: {
          total: 112.51,
          currencyCode: "USD",
          items: [
            {
              code: "CityTax",
              amount: 7.0,
              currencyCode: "USD",
              description: "government tax",
            },
            {
              code: "CityTax",
              amount: 91.8,
              currencyCode: "USD",
              description: "Destination fee",
            },
            {
              code: "CityTax",
              amount: 13.71,
              currencyCode: "USD",
              description: "City tax",
            },
          ],
        },
        taxes: {
          total: 9.08,
          currencyCode: "USD",
          items: [
            {
              code: "Vat",
              amount: 9.08,
              currencyCode: "USD",
              description: "Tax",
            },
          ],
        },
        hotelFees: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        hotelFeeTaxes: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        rooms: [
          {
            roomCode: "4cdc2bb3-ab9a-4fce-9afc-d6571a01c853",
            roomName: "Standard Room",
            boardCode: "HalfBoard",
            boardDescription: "Half Board",
            checkIn: "2025-08-18",
            checkOut: "2025-08-20",
          },
        ],
        dealPrice: {
          currencyCode: "USD",
          nightlyPrice: 77.2,
          totalRoomsPrice: 154.41,
          totalPrice: 276.0,
          totalPriceWithHotelFees: 276.0,
          totalRoomsPriceWithHotelFees: 154.41,
        },
        verificationStatus: "VerificationFailed",
        dealIndex: 1,
        roomDealIndex: 1,
        roomIndex: 1,
        roomId: 101,
      },
      {
        cancellationPolicyEnforced: null,
        checkoutId: "5df697f2-0cf8-4bad-b064-bd51ae4da4db",
        dealType: "FullRange",
        roomName: "Deluxe Room",
        roomCode: "7bf9a2ea-ec1d-4215-b4cf-559b61f035be",
        boardCode: "FullBoard",
        boardDescription: "Full Board",
        checkIn: "2025-08-18",
        checkOut: "2025-08-20",
        cancellationPolicy: {
          type: "Refundable",
          deadline: "2025-08-14T11:59:59Z",
          penalties: [
            {
              from: "2025-08-14T11:59:59Z",
              to: null,
              amount: {
                amount: 306.0,
                currency: "USD",
              },
            },
          ],
          description:
            "Cancellations before Aug 14, 2025 11:59 AM (UTC) are fully refundable. Bookings canceled after Aug 14, 2025 11:59 AM (UTC) are non-refundable and cannot be amended. There is no refund for no-shows or early checkouts.",
        },
        fees: {
          total: 114.83,
          currencyCode: "USD",
          items: [
            {
              code: "CityTax",
              amount: 7.0,
              currencyCode: "USD",
              description: "government tax",
            },
            {
              code: "CityTax",
              amount: 91.8,
              currencyCode: "USD",
              description: "Destination fee",
            },
            {
              code: "CityTax",
              amount: 16.03,
              currencyCode: "USD",
              description: "City tax",
            },
          ],
        },
        taxes: {
          total: 10.62,
          currencyCode: "USD",
          items: [
            {
              code: "Vat",
              amount: 10.62,
              currencyCode: "USD",
              description: "Tax",
            },
          ],
        },
        hotelFees: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        hotelFeeTaxes: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        rooms: [
          {
            roomCode: "7bf9a2ea-ec1d-4215-b4cf-559b61f035be",
            roomName: "Deluxe Room",
            boardCode: "FullBoard",
            boardDescription: "Full Board",
            checkIn: "2025-08-18",
            checkOut: "2025-08-20",
          },
        ],
        dealPrice: {
          currencyCode: "USD",
          nightlyPrice: 90.28,
          totalRoomsPrice: 180.55,
          totalPrice: 306.0,
          totalPriceWithHotelFees: 306.0,
          totalRoomsPriceWithHotelFees: 180.55,
        },
        verificationStatus: "Verified",
        dealIndex: 2,
        roomDealIndex: 1,
        roomIndex: 2,
        roomId: 202,
      },
      {
        cancellationPolicyEnforced: null,
        checkoutId: "a1f78c5c-79ba-43f6-a64e-af0f9ba4d740",
        dealType: "FullRange",
        roomName: "Standard Double Bed Room",
        roomCode: "36537548-8870-456a-899c-3bf30e285937",
        boardCode: "AllInclusive",
        boardDescription: "All Inclusive",
        checkIn: "2025-08-18",
        checkOut: "2025-08-20",
        cancellationPolicy: {
          type: "NonRefundable",
          deadline: null,
          penalties: [
            {
              from: "2025-08-08T11:59:59Z",
              to: null,
              amount: {
                amount: 396.01,
                currency: "USD",
              },
            },
          ],
          description:
            "This room is non-refundable and cannot be changed. No-shows and early checkouts are not eligible for a refund.",
        },
        fees: {
          total: 121.8,
          currencyCode: "USD",
          items: [
            {
              code: "CityTax",
              amount: 7.0,
              currencyCode: "USD",
              description: "government tax",
            },
            {
              code: "CityTax",
              amount: 91.8,
              currencyCode: "USD",
              description: "Destination fee",
            },
            {
              code: "CityTax",
              amount: 23.0,
              currencyCode: "USD",
              description: "City tax",
            },
          ],
        },
        taxes: {
          total: 15.23,
          currencyCode: "USD",
          items: [
            {
              code: "Vat",
              amount: 15.23,
              currencyCode: "USD",
              description: "Tax",
            },
          ],
        },
        hotelFees: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        hotelFeeTaxes: {
          total: 0,
          currencyCode: "USD",
          items: [],
        },
        rooms: [
          {
            roomCode: "36537548-8870-456a-899c-3bf30e285937",
            roomName: "Standard Double Bed Room",
            boardCode: "AllInclusive",
            boardDescription: "All Inclusive",
            checkIn: "2025-08-18",
            checkOut: "2025-08-20",
          },
        ],
        dealPrice: {
          currencyCode: "USD",
          nightlyPrice: 129.49,
          totalRoomsPrice: 258.98,
          totalPrice: 396.01,
          totalPriceWithHotelFees: 396.01,
          totalRoomsPriceWithHotelFees: 258.98,
        },
        verificationStatus: "Verified",
        dealIndex: 3,
        roomDealIndex: 1,
        roomIndex: 3,
        roomId: 303,
      },
    ],
    hotelRooms: [
      {
        roomCode: "4cdc2bb3-ab9a-4fce-9afc-d6571a01c853",
        roomName: "Standard Room",
      },
      {
        roomCode: "7bf9a2ea-ec1d-4215-b4cf-559b61f035be",
        roomName: "Deluxe Room",
      },
      {
        roomCode: "36537548-8870-456a-899c-3bf30e285937",
        roomName: "Standard Double Bed Room",
      },
    ],
    cheapestDealAvailabilityState: "Available",
    roomIds: [101, 202, 303],
  };
